<template>
  <div
    v-if="showAlert"
    class="fixed inset-0 z-50 bg-black bg-opacity-50 flex flex-col items-center justify-center"
  >
    <div class="bg-white rounded-lg shadow-lg p-6 max-w-3xl w-full mx-4">
        <!-- Profile Information Banner -->
        <div class="w-full lg:max-w-[700px] mb-6">
            <div
                class="border-2 border-[#32ccd4] bg-[#e5f5f5] text-[#32ccd4] font-normal rounded px-4 py-3"
            >
                <div class="flex items-center justify-between">
                    <span>{{ $t('profile_information') }}</span>
                </div>
            </div>
        </div>

        <!-- Form Section -->
        <div v-if="!waitingAPIResponse" class="w-full lg:max-w-[700px] px-4">
        <!-- Header -->
        <div class="flex items-center justify-between mb-6">
            <h1 class="text-2xl font-semibold">{{ $t('my_information') }}</h1>
            <div class="flex">
                <!-- <button
                @click="openFileSelector"
                class="ml-2 px-3 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 flex items-center"
                >
                <i
                    v-if="!uploadPending"
                    class="fa fa-image mr-2 hidden md:inline"
                    aria-hidden="true"
                ></i>
                <span v-if="!uploadPending" class="hidden md:inline">{{
                    $t('update_avatar')
                }}</span>
                <span v-if="!uploadPending" class="md:hidden">Avatar</span>
                <div v-if="uploadPending" class="w-28">
                    <img
                    width="20"
                    src="@/assets/img/gif/load2.gif"
                    alt="loader"
                    />
                </div>
                </button> -->
                <!-- <button class="w-full flex items-center justify-center gap-3 bg-spect text-white p-2 rounded-6 hover:bg-opacity-90 transition-colors btn-disable" @click="openFileSelector">
                    <i v-if="!uploadPending" class="fa fa-image mr-2 hidden md:inline text-white" aria-hidden="true"
                    ></i>
                    <span v-if="!uploadPending" class="hidden md:inline">{{
                        $t('update_avatar')
                    }}</span>
                    <span v-if="!uploadPending" class="md:hidden">Avatar</span>
                    <div v-if="uploadPending" class="w-28">
                        <img
                        width="20"
                        src="@/assets/img/gif/load2.gif"
                        alt="loader"
                        />
                    </div>
                </button>
                <input
                    type="file"
                    ref="fileSelector"
                    @change="uploadImage"
                    class="hidden"
                /> -->
            </div>
        </div>

            <!-- Avatar -->
            <!-- <section
            class="flex justify-center items-center py-6 bg-gray-100 rounded-lg"
            >
                <img
                    class="bg-white p-1 w-36 h-36 rounded-full object-cover"
                    :src="userData?.image_url || defaultImage"
                    alt="User Avatar"
                />
            </section> -->
            <!-- Name & Email -->
            <section class="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                <div>
                    <label for="inputFirstname" class="block text-sm font-medium mb-1"
                        >{{ $t('first_name') }}<span class="text-red-500">*</span></label
                    >
                    <input
                        id="inputFirstname"
                        :value="firstname"
                        @input="$emit('update:firstname', $event.target.value)"
                        type="text"
                        class="w-full px-4 py-2 input input-bordered ui-input"
                    />
                </div>
                <div>
                    <label for="inputLastname" class="block text-sm font-medium mb-1"
                        >{{ $t('last_name') }}<span class="text-red-500">*</span></label>
                        <input id="inputLastname" :value="lastname" @input="$emit('update:lastname', $event.target.value)" type="text" class="w-full px-4 py-2 input input-bordered ui-input" />
                </div>
                <div>
                    <label for="inputEmail" class="block text-sm font-medium mb-1"
                        >E-mail</label
                    >
                    <input
                        id="inputEmail"
                        :value="userData.email"
                        type="email"
                        disabled
                        class="w-full border border-gray-300 rounded px-3 py-2 bg-gray-100 text-gray-600"
                    />
                </div>
            </section>

            <!-- Phones & Company -->
            <section class="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
                <!-- <div>
                <label class="block text-sm font-medium mb-1"
                    >{{ $t('personal_phone') }}<span class="text-red-500">*</span></label
                >
                <input-phone
                    :init-value="
                    phonePersonal?.startsWith('+')
                        ? phonePersonal
                        : `${phonePersonal || ''}`
                    "
                    @updateNumber="(number) => $emit('update:phonePersonal', number)"
                />
                </div> -->
                <div class="col-span-2">
                    <label class="block text-sm font-medium mb-1">{{
                        $t('professional_phone')
                    }}</label>
                    <input-phone
                        :init-value="
                        phoneProfessional?.startsWith('+')
                            ? phoneProfessional
                            : `${phoneProfessional || ''}`
                        "
                        @updateNumber="(number) => $emit('update:phoneProfessional', number)"
                    />
                </div>
                <div>
                <label class="block text-sm font-medium mb-1">Entreprise</label>
                <input
                    :value="userData.organisation_detail?.name"
                    type="text"
                    disabled
                    class="w-full border border-gray-300 rounded px-3 py-2 bg-gray-100 text-gray-600"
                />
                </div>
            </section>

            <!-- Actions -->
            <div class="mt-6 flex justify-between items-center">
                <span class="text-sm text-gray-600">{{ $t('valid_information') }}</span>
                <button
                @click="updateUserProfil"
                class="flex items-center justify-center gap-3 bg-spect text-white p-2 rounded-6 hover:bg-opacity-90 transition-colors btn-disable"
                >
                {{ $t('continue') }}
                </button>
            </div>
        </div>

        <!-- Loading -->
        <div v-if="waitingAPIResponse" class="flex justify-center items-center h-full">
        <div class="flex flex-col items-center">
            <img
            src="@/assets/brand/cfa-favicon1.png"
            alt="loader"
            class="w-16 h-16 mb-2"
            />
            <span class="text-gray-700 font-semibold">{{ $t('loading') }}</span>
        </div>
        </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { ref, defineEmits, defineProps } from 'vue'
import InputPhone from '@/components/shared/input/InputPhone.vue'

const props = defineProps({
  showAlert: Boolean,
  waitingAPIResponse: Boolean,
  uploadPending: Boolean,
  userData: Object,
  defaultImage: String,
  firstname: String,
  lastname: String,
  phonePersonal: String,
  phoneProfessional: String
})

const emit = defineEmits([
  'update:firstname',
  'update:lastname',
  'update:phonePersonal',
  'update:phoneProfessional',
  'uploadImage',
  'updateUserProfil'
])

const fileSelector = ref(null)

function openFileSelector() {
  fileSelector.value?.click()
}

function uploadImage(event) {
  emit('uploadImage', event)
}

function updateUserProfil() {
  emit('updateUserProfil')
}
</script>

<style lang="scss" scoped>
@use "../../assets/scss/tailwinds.scss";

</style>